import React, { useState, useEffect } from "react"
import SideMenuDesktop from "./SideMenuDesktop"
import SideMenuMobile from "./SideMenuMobile"

function SideMenuSwitcher({ platform, controller }) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1279) // Breakpoint for smallest screens
    }

    // Handle SSR
    if (typeof window !== "undefined") {
      handleResize()
      window.addEventListener("resize", handleResize)
      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }
  }, [])

  if (!platform) return null

  return isMobile ? (
    <SideMenuMobile platform={platform} controller={controller} />
  ) : (
    <SideMenuDesktop platform={platform} controller={controller} />
  )
}

export default SideMenuSwitcher
